import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getCurrentRichContent } from "../helpers/richContentHelpers";

const simpleContactPageTplData = (id) => {
    const data = useStaticQuery(
        graphql`
            {
                allWpPage {
                    edges {
                        node {
                            id
                            template {
                                ... on WpTemplate_SimpleContact {
                                    simpleContactRichContent {
                                        # SECTION: Page Header
                                        pageHeader {
                                            header
                                            text
                                        }

                                      # SECTION: FAQ
                                      faqSection {
                                        header
                                        items {
                                          question
                                          answer
                                        }
                                    }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `
    );

    return getCurrentRichContent(data, id, "simpleContactRichContent");
};

export { simpleContactPageTplData };
